import React from 'react';
import Hero from './hero';
import Features from './features';
import GuideSucc from './guideSucc';
import Steps from './steps';
import Promote from './promote';
import Faqs from './faqs';

export default function Affiliates() {
  return (
    <div className="bg-white">
      <Hero />
      <Features />
      <GuideSucc />
      <Steps />
      <Promote />
      <Faqs />
    </div>
  );
}
